export default __webpack_public_path__ + "static/media/Boton_5.264ab666.png";